<template>
    <div
        v-if="!!old && !forceHide"
        class="cursor-pointer"
        @click="emit"
        @mouseenter="valueShown = true"
        @mouseleave="valueShown = false"
    >
        <icon
v-if="!isNew"
            :label="''"
            class="text-pink-600"
            name="clock"
        />
        <icon
v-else
            name="plus"
            class="text-teal-600"
        />
        <div v-if="!isNew" v-show="valueShown" class="relative">
            <div
               class="absolute flex flex-col rounded-xl bg-pink-600 text-white bottom-6 shadow-lg w-max z-20 px-4 py-3"
               :class="{ 'right-0': right }"
            >
                <div class="text-base">Aperçu des changements</div>
                <div class="text-sm" v-html="displayValue"></div>
            </div>
        </div>

        <div v-else v-show="valueShown" class="relative">
            <div
                class="absolute rounded-md bg-teal-600 text-white px-4 py-3 bottom-6 shadow-lg w-max z-20"
                :class="{ 'right-0': right }"
            >
                <div class="text-sm w-full">Importer depuis le Neopass</div>
            </div>
        </div>

    </div>
</template>
<script>
import Icon from '../../../components/Icon';

export default {
  name: 'CVNewValue',
  components: {Icon},

  props: {
    old: {
      type: Boolean | String,
      required: true,
    },
    right: {
      type: Boolean,
      required: false,
      default: true
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      valueShown: false,
      depth: 0,
      keyStack: [],
      unchanged: [],
      justEnteredArray: false,
      justQuitArray: false,
      ulClassList: 'list-disc',
      olClassList: 'list-decimal list-inside',
      forceHide: false
    };
  },
  methods: {
    emit(){
      this.isNew ? this.addNew() : this.setNewValue();
    },
    setNewValue() {
      this.$emit('change', this.old);
      this.forceHide = true;
    },

    addNew() {
      this.$emit('addNew', {fromNeopass: true, isDisplayed: false, value: this.old});
      this.forceHide = true;
    },
    *traverse(item) {
      switch (item?.constructor) {
      case Object:
        for (const key in item) {
          (yield [key, item[key]],
          (this.depth++,
          yield *this.traverse(item[key]),
          this.depth--
          )
          );
        }

        break;

      case Array:
        for (let i = 0; i < item.length; i++) {
          this.justEnteredArray = i === 0 ? true : this.justEnteredArray;
          (yield [i, item[i]],
          (this.depth++,
          yield *this.traverse(item[i]),
          this.depth--
          )
          );
          this.justQuitArray = (i+1) >= item.length ? true : this.justQuitArray;
        }

        break;

      default:
        break;
      }
    },

    stringFromObject(key, value, base_string = ''){
      let result = base_string;

      let key_is_ignored = ['value'].includes(key);
      let no_key = key === '';

      let no_value = value === '';
      let value_is_object = typeof value === typeof {};
      let value_is_unchanged = value === 'Identique';
      let printable_value = value_is_object ? '' : value;

      let list_is_unchanged = (!no_key && !key_is_ignored && Array.isArray(value) && value.every(el => el.value === false));

      if (key_is_ignored && no_value){
        return result;
      }

      if(value_is_unchanged && key_is_ignored){
        this.unchanged.push(this.snake_caseToCapitalized(this.keyStack[0]));
      }

      if(value_is_unchanged && !key_is_ignored){
        this.unchanged.push(this.snake_caseToCapitalized(key));
      }

      if(list_is_unchanged){
        return result;
      }

      if(this.justEnteredArray){
        result = result+'<ol class=\''+this.olClassList+'\'>';
        this.justEnteredArray = false;
      }

      if(this.justQuitArray){
        result = result+'</ol>';
        this.justQuitArray = false;
      }

      if(value_is_unchanged){
        return result;
      }

      if (key_is_ignored && !value_is_object){
        result = result+'<li>'+printable_value+'</li>';
      }


      if (!no_key && !key_is_ignored) {
        result = result+'<li>'+this.snake_caseToCapitalized(key)+': '+printable_value+'</li>';
      }

      return result;
    },

    snake_caseToCapitalized(string){
      string = string.replace(/(_.)/ig, ($1) => {
        return $1.toUpperCase()
          .replace('_', ' ');
      });
      string = string.replace(string.charAt(0), string.charAt(0).toUpperCase());
      return string;
    },

    format(value, customBool){
      let _true = customBool?._true ? customBool?._true : '✔️';
      let _false = customBool?._false ? customBool?._false : '❌️';
      switch (value?.constructor){
      case Boolean:
        return value ? _true : _false;
      case String:
        if(Date.parse(value)){
          return new Date(value).toLocaleDateString();
        }
        return value;
      case Number:
        return value.toString();
      default:
        return value;
      }
    }
  },

  computed: {
    displayValue() {
      const dateRegex = /\d{4}(-\d{2}){2}([A-Z](\d{2}:){2}\d{2}.\d{3}[A-Z])*/;
        
      if (typeof this.old === typeof '') {
        if (dateRegex.test(this.old)) {
          return new Date(this.old).toLocaleDateString();
        }
        return this.old;
      }
      if (Array.isArray(this.old)) {
        let returnValue = '';
        for (let i = 0; i < this.old.length; i++) {
          returnValue += i === this.old.length - 1 ? this.old[i].toString() : this.old[i].toString() + ', ';
        }
        return returnValue;
      }
      if (typeof this.old === typeof {}) {
        let returnValue = '<ul class=\''+this.ulClassList+'\'>';
                
        for (const [k, v] of this.traverse(this.old)){
          let key = typeof k === 'number' ? '' : k;

          let value = this.format(v, {_false: 'Identique'});


          returnValue = this.stringFromObject(key, value, returnValue);
          if(Array.isArray(v)){
            this.keyStack.unshift(k);
          }
        }
        return returnValue+'</ul>';
      }
    }
  }
};
</script>
